// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/323d741bbd1466d744d7.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"c77bd59ef631b38b32ee","191":"f1c36f32949f0d231b61","192":"af8e50668a8904176e8d"}[chunkId] + ".chunk.js";
};